import InputLabel from "components/InputLabel/InputLabel";
import React from "react";
import ReactQuill from "react-quill";
import "./TextEditor.scss";

interface Props {
  setValue: React.Dispatch<React.SetStateAction<string>>;
  value: string;
  lable?: string;
  required?: boolean;
  removeLable?: boolean;
}

const TextEditor: React.FC<Props> = ({
  value,
  setValue,
  lable = "",
  required = false,
  removeLable = false,
}) => {
  const modules = {
    toolbar: [
      ["blockquote", "strike", "underline", "italic", "bold"],
      [{ list: "ordered" }, { list: "bullet" }, { align: [] }],
      [{ color: [] }, { background: [] }],
      ["link"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };
  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
      className='text-editor-component-parent'
    >
      {removeLable ? null : (
        <InputLabel forId={""} lable={lable} required={required} />
      )}
      <ReactQuill
        modules={modules}
        theme="snow"
        value={value}
        onChange={setValue}
      />
    </div>
  );
};

export default TextEditor;
